import ObjectPath from "@re-flex/object-path";

export type I18nHttpRule = {
  // as like /public/i18n OR https://www.example.com/public/i18n
  path: string;
  headers?: Headers;
};

type AnyObject = { [k: string]: any };

export type I18nInit = {
  httpConfig?: I18nHttpRule;
  resources?: AnyObject;
  languages?: string[];
  namespaces?: string[];
  initialLanguage?: string;
};

class I18nCore {
  // parent increment state
  updater?: () => void;
  private httpConfig?: I18nHttpRule;
  browserLanguage =
    (navigator.languages && navigator.languages[0]) || navigator.language;
  initialLanguage: string = "en";
  currentLanguage: string = "en";
  resources: ObjectPath<AnyObject> = new ObjectPath({});
  private languages?: string[];
  private namespaces?: string[];
  constructor() {
    this.currentLanguage = "en";
    this.initialLanguage = "en";
  }

  private httpBackendAdapter() {
    if (!!this.httpConfig) {
      const pathMapper = this.namespaces.map((namespace) => {
        let rObject = {
          lng: this.currentLanguage,
          ns: namespace,
        };
        return {
          namespace,
          path: this.httpConfig.path.replace(/{{\s*\w+\s*}}/gim, (t) => {
            let key = t.replace(/{{\s*|\s*}}/gim, "");
            return rObject[key];
          }),
        };
      });
      Promise.all(
        pathMapper.map(({ namespace, path }) =>
          fetch(path, { headers: this.httpConfig?.headers })
            .then((r) => {
              return r.json();
            })
            .then((result) => ({ [namespace]: result }))
        )
      ).then((namespaces) => {
        this.resources = new ObjectPath(Object.assign({}, ...namespaces));
        if (this.updater) this.updater();
      });
    } else {
      console.warn("HTTP config is not assigned");
    }
  }

  init(config: I18nInit) {
    const { initialLanguage, httpConfig, resources, languages, namespaces } =
      config;
    if (!!resources) this.resources = new ObjectPath(resources);
    if (!!languages) this.languages = languages;
    if (!!namespaces) this.namespaces = namespaces;
    if (!!initialLanguage) {
      this.initialLanguage = initialLanguage;
      this.currentLanguage = initialLanguage;
    }
    if (!!httpConfig) {
      this.httpConfig = httpConfig;
      this.httpBackendAdapter();
    }
  }
  onLoadNamepaces(cb: (err?: Error) => void) {}
  onChangeLanguage(cb: (err?: Error) => void) {}
  changeLanguage(lang: string) {
    this.currentLanguage = lang;
    this.httpBackendAdapter();
    if (this.updater) this.updater();
  }
  translate(path: string, rObject?: AnyObject): string {
    let getWords = this.resources.get(
      [this.currentLanguage, path].join(".")
    ) as string | undefined;
    if (getWords === undefined) return path;
    if (!!rObject) {
      getWords = getWords.replace(/{{\s*\w+\s*}}/gim, (t) => {
        let key = t.replace(/{{\s*|\s*}}/gim, "");
        return rObject[key];
      });
    }
    return getWords;
  }
}

export type I18nType = I18nCore & {};

export const I18n = new I18nCore();
